import {CreateOperationalEntityResult} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreateResult} from "../view-model";

export const toCreateResult = (
  result: CreateOperationalEntityResult
): CreateResult => ({
  caId: result.sources[0].sourceId,
  oeId: result.id,
  dbaName: result.dbaName,
  status: result.status,
  message: result.message
});
